/* eslint-disable complexity */
/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import ReadMore from '@tcp/core/src/components/features/browse/ProductListing/molecules/ReadMore/views';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import SeoHeaderSection from '@tcp/core/src/components/common/molecules/SeoHeaderSection';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import { globalCommonBrowseLabels } from '@tcp/core/src/utils/labels/globalCommonBrowseLabels.labels';
import { getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { scrollToTop, getAPIConfig, parseBoolean } from '@tcp/core/src/utils/';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';
import { PLPLabels } from '@tcp/core/src/utils/labels/browse/PLP.labels';
import CategoryPromotion from '../../CategoryListingPage/molecules/CategoryPromotion/views/CategoryPromotion.view';
import { findCategoryFilterData } from '../../ProductListing/container/PlpCarousel.utils';
import style, { CategoryGroup, StyledFilterContainer } from '../styles/HorizontalCategory.style';
import { formatHlpProducts, getL2SiblingsData } from './helpers/hlpDataHelper';
import useFetchOnScroll from './hooks/useFetchOnScroll';
import HorizontalCarouselDesktop from './HorizontalCarouselDesktop';
import HorizontalSBCCarousel from './HorizontalSBCCarousel';
import HorizontalCarouselSkeleton from '../molecules/HorizontalCarousel/HorizontalCarouselSkeleton';
import { isShopThisStoreModeOn } from '../../../../../reduxStore/selectors/session.selectors';
import PromoModules from '../../../../common/organisms/PromoModules';
import {
  getIsVariation3OutfitCarousel,
  getNavigationTree,
  getShowCmsCarouselFlag,
  showNewCarousel,
} from '../../CategoryListingPage/container/CategoryListingPage.utils';
import CarouselSkeleton from '../../CategoryListingPage/molecules/CarouselSkeleton';
import {
  StyledLoaderSkelton,
  TopPromoWrapper,
  TopPromoWrapperV3,
} from '../../CategoryListingPage/styles/PaginatedPage.style';
import EmptyCategoryPage from '../../CategoryListingPage/molecules/EmptyCategoryPage/views/EmptyCategoryPage.view';
import { PROMO_FLAGS } from '../../../../../constants/plp.constants';

const CategoryFilters = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "category-filters" */ '../../CategoryListingPage/molecules/ClpFilters/container/ClpFilters.container'
    ),
  {
    ssr: false,
    loading: () => {
      return <StyledLoaderSkelton />;
    },
  }
);

const renderSeoHeader = (
  isSeoHeaderAlignTopEnabled,
  isSeoHeaderCopyLoaded,
  seoHeaderCopy,
  hidePlpGridAndFilters
) => {
  return isSeoHeaderAlignTopEnabled && !hidePlpGridAndFilters && !isEmpty(seoHeaderCopy) ? (
    <>
      <SeoHeaderSection
        isSeoHeaderCopyLoaded={isSeoHeaderCopyLoaded}
        seoHeaderCopy={seoHeaderCopy}
        viewMode={'tablet'}
      />
      <SeoHeaderSection
        isSeoHeaderCopyLoaded={isSeoHeaderCopyLoaded}
        seoHeaderCopy={seoHeaderCopy}
        viewMode={'desktop'}
        addExtraMarginLeft
      />
    </>
  ) : (
    <></>
  );
};

const HorizontalCategoryView = (props) => {
  const plpGenericCarouselDefaultTitle = getLabelFromCopyOrFromTranslation(
    'global.CommonBrowseLabels.lbl_plp_carousel_default_title',
    globalCommonBrowseLabels
  );

  const shopAllLabel = getLabelFromCopyOrFromTranslation('PLP.plpTiles.lbl_shop_all', PLPLabels);
  const {
    cid,
    className,
    onQuickViewOpenClick,
    onAddItemToFavorites,
    onSetLastDeletedItemIdAction,
    wishListData,
    submitButtonText,
    isShortImage,
    breadCrumbs,
    navigationData,
    horizontalPlpProducts = [],
    currentNavIds,
    getMoreHorizontalCategoryActn,
    currentCid,
    pathName,
    saveProductDataForPdp,
    saveProductDataForQV,
    trackWishListClick,
    brandId,
    isTopRatedBackAbEnabled,
    isBestSellerBackAbEnabled,
    isPLPCarouselEnabled,
    trackHorizontalPlpAnalytic,
    isSyteEnabled,
    isNewSwatchUrlEnabled,
    addToBagIconInPLP,
    horizontalPlpProductsSeoData,
    isNewSBCImplementationEnabled,
    plpTopPromos,
    dynamicPromoModules,
    longDescription,
    addToBagEcom,
    isOneClickATCEnabled,
    isHideOriginalPriceAndMarchantTagEnabled,
    sbcTypeValue,
    isHplpCmsSbcEnabled,
    isGenericSBCRedesignEnabled,
    isInfluencerBadgeEnabled,
    setFromHplpFlag,
    isTileRedesignAB,
    initialValues,
    recordsPerPage,
    selectedPageProductCount,
    sortByRatingLabel,
    setClickAnalyticsData,
    router,
    isHplpFiltersEnabled,
    promotionsData,
    isLoading,
    setIsHplpPage,
    currentNavId,
    seoHeaderCopy,
    isSeoHeaderCopyLoaded,
    isSeoHeaderAlignTopEnabled,
    shouldRenderSkeletonComponent,
    HPLPCategories,
    outfitCarouselPillCategories,
    layoutFetched,
    isOutfitCarouselPillDesignEnabled,
    outfitCarouselPillCategoriesAB,
    isPromoCallCompleted,
    hasTopPromos,
    isOutfitPillVariationEnabledOnAllPlps,
    hidePlpGridAndFilters,
  } = props;

  const commonProps = {
    onQuickViewOpenClick,
    onAddItemToFavorites,
    onSetLastDeletedItemIdAction,
    wishListData,
    submitButtonText,
    isShortImage,
    pathName,
    saveProductDataForPdp,
    saveProductDataForQV,
    addToBagIconInPLP,
    addToBagEcom,
    isOneClickATCEnabled,
    isHideOriginalPriceAndMarchantTagEnabled,
    isInfluencerBadgeEnabled,
    router,
  };
  const hasMounted = useHasMounted();
  const [inView, setInView] = useState(true);
  const filterRef = useRef();
  const parentCategory = currentNavIds[currentNavIds.length - 1];
  const hlpProductBlocks = horizontalPlpProducts[parentCategory] || [
    { categoryInfo: {}, products: [], numberOfProducts: 0 },
  ];
  const filledHlpProductBlocks = formatHlpProducts(horizontalPlpProducts, parentCategory); // Removed Empty product objects
  const catLevel = currentNavIds.length;

  useEffect(() => {
    const handleRouteChange = () => {
      const prevCatId = getLocalStorage('prevCatId');
      if (HPLPCategories?.includes(prevCatId)) {
        scrollToTop();
      }
    };
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router, shouldRenderSkeletonComponent]);

  useFetchOnScroll({
    getMoreHorizontalCategoryActn,
    currentCid,
    horizontalPlpProducts: hlpProductBlocks,
    fetchedProductLength: filledHlpProductBlocks.length,
  });

  useEffect(() => {
    setIsHplpPage(true);
  }, []);

  const navTree = useMemo(() => {
    return getNavigationTree(navigationData, pathName);
  }, [navigationData, pathName]);

  // topCarouselData is fetced only when landed on L2 category
  let topCaroseldata;
  if (isNewSBCImplementationEnabled) {
    topCaroseldata = findCategoryFilterData(navigationData, currentNavIds, shopAllLabel)[0]
      ?.carouselData;
  } else {
    topCaroseldata =
      catLevel === 2 ? getL2SiblingsData(navigationData, currentNavIds[0], currentNavIds[1]) : [];
  }

  const genericCarouselData = {
    carouselData: topCaroseldata,
  };
  const showGenericCarousel = showNewCarousel(
    plpTopPromos,
    isPLPCarouselEnabled,
    genericCarouselData,
    sbcTypeValue
  );

  const renderCarousel = ({ categoryInfo, products, numberOfProducts }, horizontalBlockIndex) => {
    return products?.length && !shouldRenderSkeletonComponent ? (
      <HorizontalCarouselDesktop
        key={categoryInfo.id}
        {...commonProps}
        categoryInfo={categoryInfo}
        products={products}
        numberOfProducts={numberOfProducts}
        trackWishListClick={trackWishListClick}
        isTopRatedBackAbEnabled={isTopRatedBackAbEnabled}
        isBestSellerBackAbEnabled={isBestSellerBackAbEnabled}
        isSyteEnabled={isSyteEnabled}
        trackHorizontalPlpAnalytic={trackHorizontalPlpAnalytic}
        isNewSwatchUrlEnabled={isNewSwatchUrlEnabled}
        horizontalBlockIndex={horizontalBlockIndex}
        horizontalPlpProductsSeoData={horizontalPlpProductsSeoData}
        isTileRedesignAB={isTileRedesignAB}
        promotionsData={promotionsData}
      />
    ) : (
      <HorizontalCarouselSkeleton key={categoryInfo.id} />
    );
  };
  const pillCategoriesArray = outfitCarouselPillCategories?.split(',');
  const pillCategoriesABVal = outfitCarouselPillCategoriesAB?.split(',');
  const isPillVariation =
    Array.isArray(pillCategoriesArray) &&
    pillCategoriesArray.length > 0 &&
    pillCategoriesArray.some((element) => {
      return element?.trim()?.toString() === currentNavId?.trim()?.toString();
    });
  const isPillVariationAB =
    isOutfitCarouselPillDesignEnabled &&
    Array.isArray(pillCategoriesABVal) &&
    pillCategoriesABVal.length > 0 &&
    pillCategoriesABVal.some((element) => {
      return element?.trim()?.toString() === currentNavId?.trim()?.toString();
    });
  const isPillEnabled = isPillVariation || isPillVariationAB;

  const renderTopCmsPromos = (isPromoForMobile, currentListingName) => {
    return (
      <PromoModules
        plpTopPromos={plpTopPromos}
        dynamicPromoModules={dynamicPromoModules}
        currentListingName={currentListingName}
        isPromoForMobile={isPromoForMobile}
        setFromHplpFlag={setFromHplpFlag}
        currentPathName={cid}
        fromHplp
        isOutfitCarouselPillDesignEnabled={isPillEnabled}
        isOutfitPillVariationEnabledOnAllPlps={isOutfitPillVariationEnabledOnAllPlps}
      />
    );
  };

  // getCategoryGroupHeader: only called for L1s
  const getCategoryGroupHeader = (groupName, top) => {
    return (
      <CategoryGroup key={groupName} top={top}>
        <span>{groupName}</span>
      </CategoryGroup>
    );
  };

  const insertCategoryGroups = useCallback(
    (carouselList) => {
      let i = 0;
      const productList = [];
      let groupName = hlpProductBlocks[0].categoryInfo.groupIdentifierName;
      let top = 10;
      if (hlpProductBlocks[0]?.numberOfProducts)
        productList.push(getCategoryGroupHeader(groupName, top));
      // To handle empty categories after filtering,
      let numberOfEmptyCategories = 0;
      while (i + numberOfEmptyCategories <= carouselList.length) {
        if (hlpProductBlocks[i]?.categoryInfo?.groupIdentifierName === groupName) {
          productList.push(carouselList[i]);
          i += 1;
        } else {
          groupName = hlpProductBlocks[i]?.categoryInfo?.groupIdentifierName;
          top = 30;
          if (hlpProductBlocks[i]?.numberOfProducts) {
            productList.push(getCategoryGroupHeader(groupName, top));
          } else {
            numberOfEmptyCategories += 1;
          }
        }
      }
      return productList;
    },
    [hlpProductBlocks]
  );

  const productCount = useMemo(() => {
    return hlpProductBlocks.reduce((acc, val) => {
      return acc + val?.products?.length;
    }, 0);
  }, [hlpProductBlocks]);

  const getCarouselList = () => {
    const carouselList = [];
    let i = 0;
    hlpProductBlocks.forEach((horizontalBlock) => {
      const { categoryInfo, numberOfProducts } = horizontalBlock;
      if (typeof numberOfProducts === 'undefined' || numberOfProducts > 0 || !categoryInfo?.id) {
        carouselList[i] = renderCarousel(horizontalBlock, i);
      }
      i += 1;
    });
    return carouselList;
  };
  const renderProducts = useCallback(() => {
    if (hlpProductBlocks) {
      let productList = getCarouselList();
      if (catLevel === 1 && hlpProductBlocks[0]?.categoryInfo.groupIdentifierName) {
        productList = insertCategoryGroups(productList);
      }
      return productList;
    }
    return null;
  }, [
    hlpProductBlocks,
    wishListData,
    horizontalPlpProductsSeoData,
    isInfluencerBadgeEnabled,
    promotionsData,
    shouldRenderSkeletonComponent,
  ]);
  const currentListingName = breadCrumbs[breadCrumbs.length - 1].displayName || '';
  const showCmsCarousel = getShowCmsCarouselFlag(showGenericCarousel, sbcTypeValue, plpTopPromos);

  const TopPromoWrapperStyle = getIsVariation3OutfitCarousel(
    isGenericSBCRedesignEnabled,
    showGenericCarousel,
    plpTopPromos
  )
    ? TopPromoWrapperV3
    : TopPromoWrapper;

  const SkeletonCmp = () => {
    return (
      <div
        className={`hplp-carousel-skeleton-${currentCid} ${
          isPillEnabled ? '' : 'carousel-skeleton'
        }`}
      >
        <CarouselSkeleton isOutfitCarouselPillDesignEnabled={isPillEnabled} />
      </div>
    );
  };

  const PromoCmp = () => {
    return (
      showCmsCarousel &&
      isHplpCmsSbcEnabled && (
        <>
          <TopPromoWrapperStyle className="topWrapper" tablet isPillVariation={isPillEnabled}>
            {renderTopCmsPromos(true, currentListingName)}
          </TopPromoWrapperStyle>
          <TopPromoWrapper desktop isHplp isPillVariation={isPillEnabled}>
            {renderTopCmsPromos(false, currentListingName)}
          </TopPromoWrapper>
        </>
      )
    );
  };

  const CMSPromoCombinations = () => {
    const isCmsCarouselAvailable = sbcTypeValue === PROMO_FLAGS.cmsBasedCarousel;
    const isEmptyPage = productCount === 0 && !isLoading && hasMounted;
    const showSkeleton = isCmsCarouselAvailable && !layoutFetched && !isEmptyPage;
    const enableCMSPromos = parseBoolean(getAPIConfig()?.enableCMSPromos) ?? false;
    if (
      enableCMSPromos &&
      isPromoCallCompleted &&
      plpTopPromos.length !== 0 &&
      plpTopPromos[0]?.moduleName
    ) {
      return <PromoCmp />;
    }

    if (enableCMSPromos && isPromoCallCompleted && hasTopPromos) {
      return <SkeletonCmp />;
    }

    if (enableCMSPromos && !isPromoCallCompleted && isCmsCarouselAvailable && !isEmptyPage) {
      return <SkeletonCmp />;
    }

    if (showSkeleton) {
      return <SkeletonCmp />;
    }

    if (showCmsCarousel && plpTopPromos.length > 0) {
      return <PromoCmp />;
    }

    return <></>;
  };

  const handleIntersect = useCallback(() => {
    const filterPos = filterRef?.current?.getBoundingClientRect()?.top;
    if (filterPos < 0) {
      setInView(false);
    } else {
      setInView(true);
    }
  }, [filterRef.current]);

  const createObserver = () => {
    const options = {
      rootMargin: '0px',
      threshold: 1.0,
    };
    const observer = new IntersectionObserver(handleIntersect, options);
    if (filterRef?.current) observer?.observe(filterRef?.current);
  };

  useEffect(() => {
    if (isHplpFiltersEnabled) {
      document.addEventListener('scroll', () => {
        createObserver();
      });
    }
    return () =>
      document.removeEventListener('scroll', () => {
        setInView(true);
      });
  }, [filterRef.current]);

  return (
    <div className={`${className} horizontal-category-view`}>
      {renderSeoHeader(
        isSeoHeaderAlignTopEnabled,
        isSeoHeaderCopyLoaded,
        seoHeaderCopy,
        hidePlpGridAndFilters
      )}
      <CategoryPromotion categoryId={currentNavId} />
      {!isShopThisStoreModeOn() && (
        <>
          {showGenericCarousel && (
            <HorizontalSBCCarousel
              topCaroseldata={topCaroseldata}
              asPath={cid}
              breadcrumbs={breadCrumbs}
              plpGenericCarouselDefaultTitle={plpGenericCarouselDefaultTitle}
              brandId={brandId}
              isPLPCarouselEnabled={isPLPCarouselEnabled}
              trackHorizontalPlpAnalytic={trackHorizontalPlpAnalytic}
              catLevel={catLevel}
              isNewSBCImplementationEnabled={isNewSBCImplementationEnabled}
            />
          )}
          <CMSPromoCombinations />
          {isHplpFiltersEnabled && !hidePlpGridAndFilters && (
            <StyledFilterContainer inView={inView} ref={filterRef}>
              <CategoryFilters
                navTree={navTree}
                pathName={pathName}
                recordsPerPage={recordsPerPage}
                initialValues={initialValues}
                selectedPageProductCount={selectedPageProductCount}
                setClickAnalyticsData={setClickAnalyticsData}
                sortByRatingLabel={sortByRatingLabel}
                isHPLP={true}
                inView={inView}
              />
            </StyledFilterContainer>
          )}
        </>
      )}
      {!hidePlpGridAndFilters && renderProducts()}
      {isHplpFiltersEnabled && !hidePlpGridAndFilters && productCount === 0 && !isLoading && (
        <EmptyCategoryPage
          navTree={navTree}
          breadCrumbs={breadCrumbs}
          isBopisFilterOn={false}
          isServiceError={false}
          isHPLP={true}
        />
      )}
      {!hidePlpGridAndFilters && (
        <ReadMore description={longDescription} className="horizontalplp-seo-text" />
      )}
    </div>
  );
};

HorizontalCategoryView.propTypes = {
  className: PropTypes.string.isRequired,
  onQuickViewOpenClick: PropTypes.func.isRequired,
  onAddItemToFavorites: PropTypes.func.isRequired,
  onSetLastDeletedItemIdAction: PropTypes.func.isRequired,
  wishListData: PropTypes.arrayOf(PropTypes.shape({})),
  submitButtonText: PropTypes.string,
  isShortImage: PropTypes.bool,
  breadCrumbs: PropTypes.arrayOf(PropTypes.shape({})),
  navigationData: PropTypes.arrayOf(PropTypes.shape({})),
  asPath: PropTypes.string,
  horizontalPlpProducts: PropTypes.arrayOf(PropTypes.shape()),
  currentNavIds: PropTypes.arrayOf(PropTypes.string),
  getMoreHorizontalCategoryActn: PropTypes.func,
  saveProductDataForPdp: PropTypes.func,
  saveProductDataForQV: PropTypes.func,
  isTopRatedBackAbEnabled: PropTypes.bool,
  isBestSellerBackAbEnabled: PropTypes.bool,
  isNewSwatchUrlEnabled: PropTypes.bool,
  isOneClickATCEnabled: PropTypes.bool,
  addToBagEcom: PropTypes.func,
  promotionsData: PropTypes.shape({}),
  isLoading: PropTypes.bool,
};
HorizontalCategoryView.defaultProps = {
  wishListData: [],
  submitButtonText: 'Add to Bag',
  isShortImage: false,
  breadCrumbs: [],
  navigationData: [],
  asPath: '',
  horizontalPlpProducts: [],
  currentNavIds: [],
  getMoreHorizontalCategoryActn: () => {},
  saveProductDataForPdp: () => {},
  saveProductDataForQV: () => {},
  isTopRatedBackAbEnabled: false,
  isBestSellerBackAbEnabled: false,
  isNewSwatchUrlEnabled: false,
  isOneClickATCEnabled: false,
  addToBagEcom: () => {},
  promotionsData: {},
  isLoading: true,
};

export { HorizontalCategoryView as HorizontalCategoryViewVanilla };
export default withStyles(HorizontalCategoryView, style);
